import {
    referralDetails,
    cashoutReferralBalance,
    referralTableHistory,
    referralChart
} from "../api/referrals";
import ResolvedException from "./exception"
import store from '../store'


export const handleGetReferralDetails = async () => {
    try {
        const response = await referralDetails(store.getters['userStore/getAuthToken']);
        store.commit('userStore/setReferralsDetail', response.data.data)
        return response
    } catch (e) {
        throw new ResolvedException(e.response.data.message, e.response.data.error)
    }
}



export const handleCashoutReferralBalance = async (cryptoAddress) => {
    try {
        const response = await cashoutReferralBalance(store.getters['userStore/getAuthToken'], cryptoAddress);
        handleGetReferralDetails()
        return response
    } catch (e) {
        // console.log(e)
        throw new ResolvedException(e.response.data.message, e.response.data.error)
    }
}

export const handleGetReferralTableHistory = async (type, page, limit) => {
    try {
        const response = await referralTableHistory(store.getters['userStore/getAuthToken'], type, page, limit);
        return response
    } catch (e) {
        throw new ResolvedException(e.response.data.message, e.response.data.error)
    }
}

export const handleGetReferralChart = async (startTime, endTime) => {
    try {
        const response = await referralChart(store.getters['userStore/getAuthToken'], startTime, endTime);
        return response;
    } catch (e) {
        throw new ResolvedException(e.response.data.message, e.response.data.error)
    }
}